module.exports = __webpack_public_path__ + "img/step3_pay.9daf4b5a.png";